module.exports = __webpack_public_path__ + "img/92.58c34bd4.jpg";